"use client";

import { usePathname } from "next/navigation";
import { Session } from "next-auth";
import { createContext, PropsWithChildren, useContext, useEffect, useState } from "react";

import { ROUTES } from "@/routes";

type TSessionProviderProps = PropsWithChildren<{
    session?: Session | null;
}>;

const sessionContext = createContext<{
    session: Session | null;
    update: () => Promise<void>;
}>({
    session: null,
    // eslint-disable-next-line no-empty-function
    update: async () => {},
});

export const SessionProvider = ({ session: initialSession = null, children }: TSessionProviderProps) => {
    const [ session, setSession ] = useState<Session | null>(initialSession);
    const pathname = usePathname();

    const fetchSession = async () => {
        const fetchedSession = await fetch(ROUTES.SESSION).then(res => res.json());
        setSession(fetchedSession);
    };

    useEffect(() => {
        if (!initialSession) {
            fetchSession();
        }
    }, [ initialSession, pathname ]);

    const update = async () => {
        await fetchSession();
    };

    return <sessionContext.Provider value={{ session, update }}>{children}</sessionContext.Provider>;
};

export const useSession = () => {
    return useContext(sessionContext);
};
